import React from 'react'

const SkillCard = ({card,index,color}) => {
  return (
     <div key={index} className="col-md-6 col-lg-3">
       
                 <div className="feature-card lifestyle-card position-relative">
                  {/* ✅ Badge (only if exists) */}
                    {card.badge && (
                      <span className="badge bg-success position-absolute top-0 end-0 m-2">
                        {card.badge}
                      </span>
                    )}
                   <div
                     className="icon-circle"
                     style={{ background: `${card.color}20`}}
                   >
                     <img src={card.img} alt='skill-area'/>
                   </div>
       
                   <h3 style={{color:color && color}} className='feature-card-content-text FS24FW500'>{card.title}</h3>
       
                   <p style={{color:color && color}} className='feature-card-content-text FS16FW500'>{card.text}</p>
       
                 </div>
       
               </div>
  )
}

export default SkillCard
